export default __webpack_public_path__ + "static/media/uml.df92ddd2.png";